import { TAddOnRefId, TProductRefId } from "@/types/plan";
import { TAddOnRules } from "../types.checkout";

/**
 * Transforms the flat add-on rules array into a lookup map keyed by plan product ref ID.
 * Each entry lists the add-on ref IDs that are allowed for that plan.
 * Multiple rules for the same plan are merged into a single array.
 *
 * @param addOnRules - Flat list of plan-to-add-on eligibility rules
 */
export function createAddOnRuleMap(addOnRules: TAddOnRules[]) {
  return addOnRules.reduce<Partial<Record<TProductRefId, TAddOnRefId[]>>>(
    (acc, rule) => {
      acc[rule.productRefId] = [
        ...(acc[rule.productRefId] || []), // fallback to empty array if not defined
        ...rule.allowedAddOns,
      ];
      return acc;
    },
    {},
  );
}
